import { Due } from '../../interfaces/CaseDetail.type';

export interface FeeWaiverHistory {
  emiNumber: number;
  agentReferenceId: string;
  waivedAmount: number;
  agentName: string;
  createdAt: string;
  reappliedAt: string | null;
  waiveStatus: string;
  emiDate: string;
}

export interface GroupedWaiverHistory {
  [key: string]: FeeWaiverHistory[];
}

export interface IFeeWaiverHistoryItem {
  feeWaiverItem: FeeWaiverHistory;
  isLastItem: boolean;
}

export enum EmiFeeActions {
  WAIVE = 'WAIVE',
  HOLD = 'HOLD',
  ADJUST = 'ADJUST'
}

export const EmiFeeActionLabelMap = {
  [EmiFeeActions.ADJUST]: 'Waive / Hold',
  [EmiFeeActions.WAIVE]: 'Waive',
  [EmiFeeActions.HOLD]: 'Hold'
};

export const FEE_WAIVER_LOADING_LIST = {
  'Dummy Section': Array.from({ length: 10 }).map(
    (_, index) =>
      ({
        createdAt: `${index}`
      } as FeeWaiverHistory)
  )
};

export interface IEmiBreakup {
  emiData: Due;
}

export const PenaltyWaivedLabelMap = {
  [EmiFeeActions.ADJUST]: 'Penalty waived / held',
  [EmiFeeActions.WAIVE]: 'Penalty waived',
  [EmiFeeActions.HOLD]: 'Penalty held'
};

export interface IFeeWaiveInfoText {
  emiData: Due;
}

export interface IFeeWaiveInfoBanner {
  emiData: Due;
}
